/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var FilterOutlineIcon = function FilterOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.60355 8.30466C1.44801 6.50838 2.71822 3 5.52411 3H18.4759C21.2818 3 22.552 6.50837 20.3965 8.30466L15 12.8017V21C15 21.3924 14.7705 21.7485 14.4132 21.9106C14.0559 22.0728 13.6368 22.011 13.3415 21.7526L9.34147 18.2526C9.12446 18.0627 8.99998 17.7884 8.99998 17.5V12.8017L3.60355 8.30466ZM5.52411 5C4.58881 5 4.16541 6.16946 4.88392 6.76822L10.6402 11.5651C10.8682 11.7551 11 12.0365 11 12.3333V17.0462L13 18.7962V12.3334C13 12.0366 13.1318 11.7551 13.3598 11.5651L19.1161 6.76822C19.8346 6.16946 19.4112 5 18.4759 5H5.52411Z"
  }));
};
export default FilterOutlineIcon;